// PC 网页版路由（history 模式）
//  - meta.layout: 'bare' 的页面不使用 PC 顶栏/页脚（web-view 独立页：登录/关注/协议/日志）
//  - meta.requiresAuth: 需要登录，未登录重定向到 /login
import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/api/request'

const routes = [
  { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue'), meta: { title: '扫码登录', layout: 'bare' } },

  // 主站页面（需要登录）
  { path: '/', name: 'home', component: () => import('@/views/HomeView.vue'), meta: { title: '配音' } },
  { path: '/voices', name: 'voices', component: () => import('@/views/VoicesView.vue'), meta: { title: '音色库' } },
  { path: '/works', name: 'works', component: () => import('@/views/WorksView.vue'), meta: { title: '作品' } },
  { path: '/works/:id', name: 'work-detail', component: () => import('@/views/WorkDetailView.vue'), meta: { title: '作品详情' } },
  { path: '/profile', name: 'profile', component: () => import('@/views/ProfileView.vue'), meta: { title: '我的' } },
  { path: '/profile/edit', name: 'profile-edit', component: () => import('@/views/ProfileEditView.vue'), meta: { title: '编辑资料' } },
  { path: '/settings', name: 'settings', component: () => import('@/views/SettingsView.vue'), meta: { title: '设置' } },

  // 独立页（web-view 打开，无需登录）
  { path: '/qrcode', name: 'qrcode', component: () => import('@/views/QrcodeView.vue'), meta: { title: '关注公众号', layout: 'bare' } },
  { path: '/terms', name: 'terms', component: () => import('@/views/TermsView.vue'), meta: { title: '用户服务协议', layout: 'bare' } },
  // 版本更新日志：路径用 /updates 而非 /changelog（服务器对该路径有拦截，会 404）
  { path: '/updates', name: 'updates', component: () => import('@/views/ChangelogView.vue'), meta: { title: '版本更新日志', layout: 'bare' } },

  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to) => {
  const token = getToken()
  // 非独立页（有 PC 顶栏的主站页面）统一要求登录
  const isBare = to.meta.layout === 'bare'
  if (!isBare && to.name !== 'login' && !token) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  // 已登录访问登录页：直接回首页
  if (to.name === 'login' && token) {
    return { path: '/' }
  }
})

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} · AI配音小狐狸` : 'AI配音小狐狸'
})

export default router
